import React from 'react';
import Logo from '../components/Logo';
import { Form, redirect, useNavigation, Link } from 'react-router-dom';
import customFetch from '../utils/customFetch';
import { toast } from 'react-toastify';
export const action = async ({ request }) => {
  const formData = await request.formData();
  const data = Object.fromEntries(formData);

  try {
    const submit = await customFetch.post('/auth/forgot-password', data);
    toast.info(submit?.data?.msg);
    return redirect('/login');
  } catch (error) {
    toast.error(error?.response?.data?.msg);
    return error;
  }
};

const ForgotPassword = () => {
  const navigation = useNavigation();
  const isSubmitting = navigation.state === 'submitting';
  return (
    <>
      <div className="h-full bg-gray-50" style={{ height: '100vh' }}>
        <div className="h-full">
          <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
              <Link to="/">
                <Logo />
              </Link>
              <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                Fordere einen Link an, um dein Passwort zurückzusetzen
              </h2>
            </div>

            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
              <div className="bg-white px-6 py-12 shadow-sm sm:rounded-lg sm:px-12">
                <Form className="space-y-6" method="POST">
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    >
                      Email
                    </label>
                    <div className="mt-2">
                      <input
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        required
                        className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>

                  <div>
                    <button
                      type="submit"
                      className="flex w-full justify-center rounded-md bg-svisit-primary-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-xs hover:bg-svisit-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-svisit-primary-600"
                      disabled={isSubmitting}
                    >
                      {isSubmitting
                        ? 'Link wird angefordert...'
                        : 'Passwort zurücksetzen'}
                    </button>
                  </div>
                </Form>
                <Link to="/login">
                  <div className="mt-4">
                    <button
                      type="button"
                      className="flex w-full justify-center rounded-md bg-white px-3 px-3 py-1.5 text-sm font-semibold leading-6 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    >
                      Zurück zum Login
                    </button>
                  </div>
                </Link>
              </div>

              {/* <p className="mt-10 text-center text-sm text-gray-500">
                Noch kein Kunde?{' '}
                <a
                  href="#"
                  className="font-semibold leading-6 text-svisit-primary-600 hover:text-svisit-primary-500"
                >
                  Jetzt gratis testen!
                </a>
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
